import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ReferralService} from './referral.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BusinessReferralModel} from '../../api/models/business-referral-model';
import {NotificationService} from '../../notification/notification.service';
import {AuthService} from '../../core/security/auth.service';
import {CurrentUser} from '../../api/models';
import { MatDialog, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

@Component({
    selector: 'app-new-business-referral',
    templateUrl: './referral.component.html',
    styleUrls: ['./referral.component.scss'],
    standalone: true,
    imports: [FlexModule, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, NgIf, MatTextInputComponent, MatPhoneNumberInputComponent, MatDialogActions, MatButton, Angular2PromiseButtonModule, MatDialogClose]
})
export class ReferralComponent implements OnInit, OnChanges {

  public form: UntypedFormGroup;
  public submitted: boolean;
  public serverError: boolean;
  buttonSubmitPromise: Promise<void>;

  onConfirm: Promise<void>;
  @Input() asyncConfirm: (filter?: any) => Promise<void>;

  constructor(
    public dialogRef: MatDialogRef<ReferralComponent>,
    public dialog: MatDialog,
    public referralService: ReferralService,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private notificationService: NotificationService
  ) {

    this.createForm();
  }

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {

    const currentUser = this.authService.currentUser.getValue() || {} as CurrentUser;

    this.submitted = false;
    this.form.reset({
      yourName: currentUser.displayName,
      yourEmail: currentUser.email,

      firstName: '',
      lastName: '',
      companyName: '',
      businessEmail: '',
      phoneNumber: '',
    });
  }

  async onSubmit() {
    this.submitted = true;
    this.serverError = false;

    if (this.form.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<void> {

    const reqData = this.prepareFormModel();

    if (await this.referralService.sendBusinessReferralEmail(reqData)) {
      this.notificationService.notifySuccess('Thank you for submitting business referral from');
      this.dialogRef.close();
    }
  }

  prepareFormModel(): BusinessReferralModel {
    const formModel = this.form.value;

    return {
      yourName: formModel.yourName,
      yourEmail: formModel.yourEmail,
      firstName: formModel.firstName,
      lastName: formModel.lastName,
      companyName: formModel.companyName,
      businessEmail: formModel.businessEmail,
      phoneNumber: formModel.phoneNumber
    };
  }

  createForm(): void {

    this.form = this.fb.group({
        'yourName': ['', Validators.required],
        'yourEmail': ['', [Validators.email, Validators.required]],
        'firstName': ['', Validators.required],
        'lastName': ['', Validators.required],
        'companyName': ['', Validators.required],
        'businessEmail': ['', [Validators.email, Validators.required]],
        'phoneNumber': ['', Validators.required],
      }
    );
  }

  async onProcessConfirm() {
    if (this.asyncConfirm) {
      this.onConfirm = this.asyncConfirm();
    }
  }

  getFormControl(controlName: string, otherForm?: UntypedFormGroup | AbstractControl): UntypedFormControl {
    if (otherForm) {
      return otherForm.get(controlName) as UntypedFormControl;
    } else {
      return this.form.get(controlName) as UntypedFormControl;
    }
  }
}
